'use client';

import { useState } from 'react';
import CarDetailHero from './HeroSection/SCarDetailHeroSection';
import CarDetailImages from './ImagesSection/SCarDetaiImagesSection';
import CarDetailDescription from './DescriptionSection/SCarDetaiDescriptionSection';
import CarDetailSecondImage from './SecondImageSection/SCarDetaiSecondImageSection';
import CarDetailTerms from './TermsAndConditionsSection/SCarDetaiTermsAndConditionsSection';

export default function SelectedCarDetail({ fields }) {
  // 添加安全检查，防止fields为undefined
  if (!fields) {
    return (
      <div className="container">
        <p>No fields data available.</p>
      </div>
    );
  }

  // 从Sitecore fields获取数据 - 适配新的数据结构
  const hero = {
    title: fields?.heroTitle?.value,
    desc: fields?.heroDesc?.value,
    buttonText: fields?.heroButtonText?.value,
    buttonTextLaptop: fields?.heroButtonTextLaptop?.value,
    buttonUrl: fields?.heroButtonUrl?.value?.href,
    image: fields?.heroImage,
  };

  const imagesBlock = {
    leftTopImage: fields?.leftTopImage,
    leftBottomImage: fields?.leftBottomImage,
    rightImage: fields?.rightImage,
  };

  const description = fields?.descriptionItem || [];

  const secondImageBlock = {
    image: fields?.secondImage,
    title: fields?.secondImageTitle?.value,
    subtitle: fields?.secondImageSubtitle?.value,
    buttonText: fields?.secondImageButtonText?.value,
    buttonUrl: fields?.secondImageButtonUrl?.value?.href,
  };

  const termsAndConditions = fields?.termsAndConditions?.value;

  // 状态管�?
  const [selectedIndex, setSelectedIndex] = useState(0);
  const selectedPackage = description?.[selectedIndex];
  const selectedTermsAndConditions =
    selectedPackage?.fields?.termsAndConditions?.value || termsAndConditions;

  return (
    <div className="container">
      <CarDetailHero data={hero} />
      <CarDetailImages
        leftTopImage={imagesBlock?.leftTopImage}
        leftBottomImage={imagesBlock?.leftBottomImage}
        rightImage={imagesBlock?.rightImage}
      />
      <CarDetailDescription
        data={description}
        title={description?.[0]?.fields?.carName?.value}
        selectedIndex={selectedIndex}
        onIndexChange={setSelectedIndex}
      />
      <CarDetailSecondImage secondImageSectionData={secondImageBlock} />
      <CarDetailTerms content={selectedTermsAndConditions} />
    </div>
  );
}
